(function () {

  function initVideoLookbook() {

    const cards = document.querySelectorAll('.video-lookbook-item');

    if (!cards.length) return;

    cards.forEach(function(card) {

      const video = card.querySelector('video');

      if (!video) return;

      video.pause();
      video.currentTime = 0;

      card.addEventListener('mouseenter', function () {

        document.querySelectorAll('.video-lookbook-item video').forEach(function(v){

          if(v !== video){

            v.pause();
            v.currentTime = 0;

          }

        });

        video.play().catch(function(){});

      });

      card.addEventListener('mouseleave', function () {

        video.pause();
        video.currentTime = 0;

      });

    });

  }

  document.addEventListener('DOMContentLoaded', initVideoLookbook);

  document.addEventListener('shopify:section:load', initVideoLookbook);

})();